export default "__VITE_ASSET__BOtUERbV__"